import { Box } from "@mui/material";

function NavBar2({svgLogo}) {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                padding: 2,
                backgroundColor: "#dce6e6",
                position: 'sticky',
                top: 0,
                zIndex: 1000,
            }}
        >
            {svgLogo}
    
        </Box>
    );
}

export default NavBar2;